import React from "react";

// Projects.jsx 페이지에서 All / Group / Personal 프로젝트를 나눠주는 탭 component.
const TAB_OPTIONS = [
  { key: "all", label: "All" },
  { key: "group", label: "Group" },
  { key: "personal", label: "Personal" },
];

export default function Tabs({ tab, counts, onChange }) {
  return (
    <div className="inline-flex rounded-xl border border-gray-300 dark:border-gray-700 p-1 bg-white dark:bg-gray-800">
      {TAB_OPTIONS.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`px-4 py-2 rounded-lg text-sm transition
            ${tab === key // tab===key인 경우, 조건부 스타일링
              ? "bg-blue-600 text-white dark:bg-blue-500"
              : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"}`}
          aria-pressed={tab === key}
        >
          {/* (프로젝트 갯수) */}
          {label} ({counts[key]})
        </button>
      ))}
    </div>
  );
}
